import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularProgress, List, ListItem, ListItemIcon } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ListItemNavLink from '../ListItemNavLink';
import {
	getSupportClosedRoute,
	getSupportInboxRoute,
	getSupportNewTicketRoute,
	getSupportOutboxRoute
} from '../../../../router/routes/support/factory/boxes';
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import SendIcon from '@mui/icons-material/Send';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import { getSupportCannedsRoute } from '../../../../router/routes/support/factory/canned';
import StorageIcon from '@mui/icons-material/Storage';
import HasRight from '../../../Route/HasRight';
import EmailIcon from '@mui/icons-material/Email';
import { fetchSupport } from '../../../../store/actions/SupportAction';

const MenuSupport = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const support = useSelector(state => state.support.support);
	const loading = useSelector(state => state.support.loading);
	const ready = useSelector(state => state.common.ready);
	const creatingArtist = useSelector(state => state.music.creating);

	const disabled = loading || support === null || !ready;

	const refreshSupport = useCallback((id) => {
		dispatch(fetchSupport(id, true, true));
	}, [dispatch]);

	useEffect(() => {
		const refreshInterval = setInterval(() => {
			if (!support || creatingArtist) return;
			refreshSupport(support.Support__);
		}, 30000);

		return () => clearInterval(refreshInterval);
	}, [support, creatingArtist, refreshSupport]);

	return (
		<List>
			{loading && (
				<ListItem>
					<ListItemIcon>
						<CircularProgress size={15} />
					</ListItemIcon>
				</ListItem>
			)}

			<ListItemNavLink
				tooltip={t('menu_support_inbox')}
				disabled={disabled}
				path={getSupportInboxRoute()}
				icon={
					<Badge color="primary" badgeContent={support ? parseInt(support.New_Ticket_Count) : 0}>
						<MailIcon />
					</Badge>
				}
				primary={t('menu_support_inbox')}
			/>

			<ListItemNavLink
				tooltip={t('menu_support_outbox')}
				disabled={disabled}
				path={getSupportOutboxRoute()}
				icon={<SendIcon />}
				primary={t('menu_support_outbox')}
			/>

			<ListItemNavLink
				tooltip={t('menu_support_closebox')}
				disabled={disabled}
				path={getSupportClosedRoute()}
				icon={<CancelScheduleSendIcon />}
				primary={t('menu_support_closebox')}
			/>

			<ListItemNavLink
				tooltip={t('menu_support_canned_response')}
				disabled={disabled}
				path={getSupportCannedsRoute()}
				icon={<StorageIcon />}
				primary={t('menu_support_canned_response')}
			/>

			<HasRight support hideLoading>
				<ListItemNavLink
					tooltip={t('menu_support_contact_user')}
					disabled={disabled}
					path={getSupportNewTicketRoute()}
					icon={<EmailIcon />}
					primary={t('menu_support_contact_user')}
				/>
			</HasRight>
		</List>
	);
};

export default MenuSupport;
